// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dqsD","inner":"Footer_inner__1EZT1","nextIcon":"Footer_nextIcon__2qgSd","innerLeft":"Footer_innerLeft__jcCFK"};